import { useSelector } from 'react-redux';
import { getNetWorthHistoryChartData } from '../NetWorthChart';

export function useNetWorthChartData(clientId: string, range: string) {
  return useSelector((state: { NetWorthReport?: Record<string, unknown> }) =>
    getNetWorthHistoryChartData(state, clientId, range),
  );
}
